import { render, staticRenderFns } from "./administratorSettings.vue?vue&type=template&id=5ded8026&scoped=true"
import script from "./administratorSettings.vue?vue&type=script&lang=js"
export * from "./administratorSettings.vue?vue&type=script&lang=js"
import style0 from "./administratorSettings.vue?vue&type=style&index=0&id=5ded8026&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ded8026",
  null
  
)

export default component.exports